
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(27|29|44)|193|313|431|471|849|912)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
